import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading.component';
import { DssTypographyModule } from '@dss/components/typography';

@NgModule({
  declarations: [LoadingComponent],
  imports: [
    CommonModule,
    DssTypographyModule
  ],
  exports:[LoadingComponent]
})
export class LoadingModule { }
